import { max } from 'd3-array';

export const getMaxOrOne = (data: any[], valueKey: string) => {
  if (!data.length) return 1;

  const maxValue = max(data, d => +d[valueKey])!;
  const maxOrOne = Math.max(maxValue, 1)
  return maxOrOne;
}